import React, { FC, useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import MailingSelector from './MailingSelector';
import MailingPreview from './MailingPreview';
import KapitalmarktexpertenTab from './KapitalmarktexpertenTab';
import SendHistory from './SendHistory';
import EvaluationTab from './EvaluationTab';
import VnrMailingTab from './VnrMailingTab';
import { NfaRecommendation } from '../../helpers/nfaMailingData';

const NfaMailings: FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedMailing, setSelectedMailing] = useState<NfaRecommendation | null>(null);
  const [plannedDate, setPlannedDate] = useState('');

  const handleSelectMailing = (mailing: NfaRecommendation, date: string) => {
    setSelectedMailing(mailing);
    setPlannedDate(date);
    setActiveTab(1);
  };

  const handleBackToSelector = () => {
    setActiveTab(0);
  };

  return (
    <Box m="20px">
      <Typography variant="h4" fontWeight="bold" mb={2}>
        NFA Mailings
      </Typography>
      <Typography variant="body2" color="textSecondary" mb={3}>
        one-stock-letter.de — Mailing-Export für NFA
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_e, val) => setActiveTab(val)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Mailing der Woche" />
        <Tab label="Vorschau & Export" disabled={!selectedMailing} />
        <Tab label="Newsletter (deaktiviert)" disabled />
        <Tab label="Verlauf" />
        <Tab label="Auswertung" />
        <Tab label="VNR Mailing" />
      </Tabs>

      {activeTab === 0 && <MailingSelector onSelect={handleSelectMailing} />}

      {activeTab === 1 && selectedMailing && (
        <MailingPreview
          mailing={selectedMailing}
          plannedDate={plannedDate}
          onBack={handleBackToSelector}
        />
      )}

      {activeTab === 2 && <KapitalmarktexpertenTab onSelect={handleSelectMailing} />}

      {activeTab === 3 && <SendHistory />}

      {activeTab === 4 && <EvaluationTab />}

      {activeTab === 5 && <VnrMailingTab />}
    </Box>
  );
};

export default NfaMailings;
